import React from 'react';
import PropTypes from 'prop-types';
import { StyledFormatTxt } from './style';

const FormatTxt = ({ className, format, href, target }) => (
  <StyledFormatTxt
    className={className}
    href={href}
    title={`Descargar ${format}`}
    target={target}
  >
    {format}
  </StyledFormatTxt>
);

FormatTxt.propTypes = {
  className: PropTypes.string,

  /** Extensión del archivo */
  format: PropTypes.string.isRequired,

  /** url del enlace */
  href: PropTypes.string,

  /** blank del enlace */
  target: PropTypes.string
};

FormatTxt.defaultProps = {
  href: undefined,
  target: '_self'
};

export default FormatTxt;
